//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'

export default {
  props: {
    label: {
      type: String,
      default: "date"
    },
    minDate: {
      type: String,
      default: null
    },
    maxDate: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    init: {
      type: Object,
      default: null
    },
    required: Boolean,
    id: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      dateMenu: false,
      dateVal: null,
      timeVal: null,
      rules: {
        startDate: [
          value => !!value || 'Required.',
        ]
      },
    };
  },
  computed: {
    dateDisp() {
      const dateTime = moment(this.dateVal + ' ' + this.timeVal, 'YYYY-MM-DD HH:mm')
      this.$emit('getDate', moment(dateTime, moment.ISO_8601))

      return this.dateVal
        ? dateTime.format('YYYY-MM-DD  HH:mm:ss')
        : ''
    },
  },
  mounted() {
    if (this.init !== null && this.init !== '') {
      this.dateVal = moment(this.init).format('YYYY-MM-DD')
      this.timeVal = moment(this.init).format('HH:mm:ss')
    }
  },

};
